import type { SandboxAdminUser, UserSelectOption } from "shell/console/types";

const toUserSelectOption = (user: SandboxAdminUser): UserSelectOption => ({
  value: user.user_id,
  label: `${user.first_name} ${user.last_name}${user.email ? ` (${user.email})` : ""}`,
});

export const toUserSelectOptions = (
  users: SandboxAdminUser[],
): UserSelectOption[] => users.map(toUserSelectOption);
